import { useTranslation } from '../../../lib/i18n';
import { readShopifyReadSource, type ShopifyReadSource } from '../../../lib/shopify-health';

export function ShopifySourceLine({ source }: { source: ShopifyReadSource }) {
  const { t } = useTranslation();
  const valid = readShopifyReadSource(source);
  if (!valid) return null;
  const identity = valid.storeName ? `${valid.storeName} · ${valid.storeDomain}` : valid.storeDomain;
  return (
    <div data-testid="shopify-source" style={{ fontSize: 12, color: 'var(--ds-text-secondary)', overflowWrap: 'anywhere' }}>
      <div>{t('connectors.shopify.source', { store: identity })}</div>
      {valid.readAt && <div>{t('connectors.shopify.updated', { date: new Date(valid.readAt).toLocaleString() })}</div>}
      {valid.status === 'partial' && (
        <div>
          {t('connectors.shopify.partial')}
          {valid.coverage ? `: ${valid.coverage}` : ''}
        </div>
      )}
      {valid.status === 'unavailable' && <div>{t('connectors.shopify.unavailable')}</div>}
    </div>
  );
}
